// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderSkeleton_wrapper_mPvGt"};